import { DeveloperIcon, LenderIcon, OwnerIcon } from "assets/icons";
import Button from "components/shared/Button";
import { FC, useState } from "react";
import { IoCheckmarkCircleOutline, IoEllipseOutline } from "react-icons/io5";
import { TbX } from "react-icons/tb";
import { useNavigate } from "react-router-dom";

interface Props {
  onClose: () => void;
}

type Role = "lender" | "developer" | "owner";

export const HomeModal: FC<Props> = ({ onClose }) => {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState<Role | null>(null);

  const handleContinue = () => {
    if (!selectedRole) return;
    switch (selectedRole) {
      case "lender":
        navigate("lender");
        break;
      case "developer":
        navigate("developer");
        break;
      case "owner":
        navigate("owner");
        break;
    }
    onClose();
  };

  const roles = [
    {
      key: "lender" as Role,
      title: "Lender",
      desc: "Gain effective oversight of the projects you finance.",
      icon: LenderIcon,
    },
    {
      key: "developer" as Role,
      title: "Property Developer",
      desc: "Access affordable finance for your projects.",
      icon: DeveloperIcon,
    },
    {
      key: "owner" as Role,
      title: "Project Owner",
      desc: "Get end-to-end project delivery",
      icon: OwnerIcon,
    },
  ];

  return (
    <div
      onClick={onClose}
      className="fixed w-screen z-[999] h-screen top-0 left-0 bg-black bg-opacity-60 flex flex-col items-center overflow-y-auto"
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="flex flex-col gap-6 max-w-[756px] p-4 lg:p-6 rounded-md bg-white w-4/5 md:w-2/3 lg:w-1/2 mt-20"
      >
        {/* Header */}
        <div className="flex items-center justify-between">
          <p className="text-xl text-blueShades-4 font-satoshi font-semibold">
            I am a...
          </p>
          <span className="cursor-pointer text-bash" onClick={onClose}>
            <TbX size={24} />
          </span>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {roles.map((role) => (
            <div
              key={role.key}
              onClick={() => setSelectedRole(role.key)}
              className={`cursor-pointer border border-[#E5EAF0] rounded-xl p-4 flex flex-col items-center justify-center gap-4 transition-all ${selectedRole === role.key ? "border-blueShades2-1" : "border-[#E5EAF0]"}`}
            >
              <div className="flex w-full justify-between">
                <img
                  src={role.icon}
                  alt=""
                  className="w-8 h-8 self-center m-auto"
                />
                <div className="">
                  {selectedRole === role.key ? (
                    <IoCheckmarkCircleOutline color="#023061" />
                  ) : (
                    <IoEllipseOutline color="#023061" />
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-2 items-center">
                <p className="font-semibold text-lg font-satoshi text-blueShades-4">
                  {role.title}
                </p>
                <p className="text-ashShade-16 text-sm text-center font-SatoshiRegular">
                  {role.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end gap-x-4">
          <Button
            onClick={onClose}
            type="secondary"
            label="Cancel"
            style={{
              backgroundColor: "transparent",
              borderColor: "#E6E7E8",
              color: "#101828",
            }}
          />
          <Button
            onClick={handleContinue}
            label="Continue"
            style={{
              backgroundColor: selectedRole ? "#023061" : "#94a3b8",
              borderColor: "#E6E7E8",
              color: "#fff",
              cursor: selectedRole ? "pointer" : "not-allowed",
            }}
            disabled={!selectedRole}
          />
        </div>
      </div>
    </div>
  );
};
